import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const CompetenceOrderRuleListItemSummary = ({ competenceOrderRule }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={2}>
        {t('CompetenceOrder.Rule.OrderId')} : <span> {competenceOrderRule.orderId} </span>
      </Grid>
      <Grid item xs={12} sm={5}>
        {t('CompetenceOrder.Rule.LevelName')} : <span> {competenceOrderRule.levelName} </span>
      </Grid>
      <Grid item xs={12} sm={5}>
        {t('CompetenceOrder.Rule.RuleStatusName')} : <span> {competenceOrderRule.ruleStatusName} </span>
      </Grid>
    </Grid>
  );
};

CompetenceOrderRuleListItemSummary.propTypes = {
  competenceOrderRule: PropTypes.object.isRequired
};

export default CompetenceOrderRuleListItemSummary;
